import { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard, ClipboardList, Users, Truck,
  UploadCloud, BarChart3, ChevronLeft, ChevronRight,
  LogOut, Settings, Search, Menu, ShieldCheck, CalendarDays, AlertTriangle,
  Scale, Fuel, BookOpen, Recycle, Wrench
} from "lucide-react";

const ValorizaLogo = ({ collapsed }) => (
  <div className={`flex items-center ${collapsed ? "justify-center" : ""}`}>
    {collapsed ? (
      <svg viewBox="50 50 160 160" className="h-9 w-9">
        <path fill="#007934" d="M123.05,99.03v-41.9H109.1v27.94L89.35,65.31l-9.86,9.86l29.63,29.63C113.08,101.75,117.85,99.7,123.05,99.03"/>
        <path fill="#3BAD2D" d="M103.85,110.07L74.22,80.44l-9.86,9.86l19.75,19.75H56.17v13.95h41.91C98.75,118.8,100.8,114.03,103.85,110.07"/>
        <path fill="#007934" d="M155.48,124.01h41.91v-13.95h-27.94l19.75-19.75l-9.86-9.86l-29.63,29.63C152.76,114.03,154.81,118.8,155.48,124.01"/>
        <path fill="#3BAD2D" d="M144.44,104.8l29.63-29.63l-9.86-9.86l-19.75,19.75V57.13h-13.95v41.91C135.71,99.7,140.48,101.75,144.44,104.8"/>
        <path fill="#007934" d="M98.08,131.46H56.17v13.95H84.1l-19.75,19.75l9.86,9.86l29.64-29.64C100.8,141.43,98.75,136.66,98.08,131.46"/>
        <path fill="#3BAD2D" d="M149.7,145.39l29.64,29.64l9.86-9.86l-19.75-19.75h27.94v-13.95h-41.91C154.81,136.66,152.76,141.43,149.7,145.39"/>
        <path fill="#3BAD2D" d="M109.12,150.66L79.49,180.3l9.86,9.86l19.75-19.75v27.94h13.95v-41.92C117.85,155.76,113.08,153.71,109.12,150.66"/>
        <path fill="#007934" d="M130.51,156.43v41.92h13.95v-27.94l19.75,19.75l9.86-9.86l-29.64-29.64C140.48,153.71,135.71,155.76,130.51,156.43"/>
      </svg>
    ) : (
      <svg viewBox="0 0 1047.16 256.38" className="h-9">
        <path fill="#FFFFFF" d="M341.5,72.42l-30.94,0l-26.39,69.9l-26.13-69.9h-31.79l42.64,107.76l1.28,3.23h23.97l1.28-3.23Z"/>
        <path fill="#FFFFFF" d="M383.11,72.42l-31.13,0l24.64,57.27h-22.33v26.77h33.65l2.38,5.64l8.92,21.31h31.91Z"/>
        <path fill="#FFFFFF" d="M470.98,72.42h-29.51v110.99h72.98v-26.95h-43.47Z"/>
        <path fill="#FFFFFF" d="M575.63,72.53c-10.53,0-20.29,2.43-28.99,7.21c-8.75,4.81-15.73,11.51-20.75,19.92c-5.03,8.42-7.58,17.87-7.58,28.1c0,10.22,2.55,19.69,7.58,28.16c5.01,8.44,11.98,15.21,20.72,20.12c8.72,4.89,18.48,7.37,29.03,7.37c10.55,0,20.32-2.48,29.04-7.37c8.73-4.9,15.71-11.67,20.72-20.12c5.03-8.47,7.58-17.94,7.58-28.16c0-10.22-2.55-19.67-7.58-28.1c-5.03-8.41-12.01-15.11-20.75-19.92C595.92,74.96,586.16,72.53,575.63,72.53ZM575.91,156.46c-5.14,0-9.75-1.24-14.11-3.81c-4.4-2.58-7.82-6-10.44-10.45c-2.61-4.41-3.87-9.13-3.87-14.45c0-5.32,1.24-10.03,3.81-14.39c2.57-4.38,5.97-7.74,10.39-10.27c4.42-2.53,9.07-3.76,14.23-3.76c5.04,0,9.59,1.22,13.91,3.74c4.33,2.53,7.67,5.88,10.2,10.26c2.52,4.37,3.75,9.09,3.75,14.42c0,5.34-1.23,10.09-3.76,14.51c-2.54,4.43-5.88,7.83-10.22,10.4C585.48,155.22,580.94,156.46,575.91,156.46Z"/>
        <rect fill="#FFFFFF" x="751.45" y="72.42" width="29.51" height="110.99"/>
        <path fill="#FFFFFF" d="M894.82,72.42h-95.59v27.06h53.42l-53.42,63.27v20.66h96.31v-27.07h-54.16l53.44-63.41Z"/>
        <path fill="#FFFFFF" d="M735.08,183.41l-23.05-34.73c10.7-7.62,17.68-20.11,17.68-34.24c0-23.21-18.81-42.02-42.02-42.02h-40.1v26.91h40.1c8.38,0,15.18,6.79,15.18,15.18s-6.79,15.18-15.18,15.18h-40.1v26.77h37.26l15.75,26.95Z"/>
        <path fill="#FFFFFF" d="M941.52,72.42l-31.13,0l24.64,57.27h-22.33v26.77h33.65l2.38,5.64l8.92,21.31h31.91Z"/>
        <path fill="#007934" d="M123.05,99.03v-41.9H109.1v27.94L89.35,65.31l-9.86,9.86l29.63,29.63C113.08,101.75,117.85,99.7,123.05,99.03"/>
        <path fill="#3BAD2D" d="M103.85,110.07L74.22,80.44l-9.86,9.86l19.75,19.75H56.17v13.95h41.91C98.75,118.8,100.8,114.03,103.85,110.07"/>
        <path fill="#007934" d="M155.48,124.01h41.91v-13.95h-27.94l19.75-19.75l-9.86-9.86l-29.63,29.63C152.76,114.03,154.81,118.8,155.48,124.01"/>
        <path fill="#3BAD2D" d="M144.44,104.8l29.63-29.63l-9.86-9.86l-19.75,19.75V57.13h-13.95v41.91C135.71,99.7,140.48,101.75,144.44,104.8"/>
        <path fill="#007934" d="M98.08,131.46H56.17v13.95H84.1l-19.75,19.75l9.86,9.86l29.64-29.64C100.8,141.43,98.75,136.66,98.08,131.46"/>
        <path fill="#3BAD2D" d="M149.7,145.39l29.64,29.64l9.86-9.86l-19.75-19.75h27.94v-13.95h-41.91C154.81,136.66,152.76,141.43,149.7,145.39"/>
        <path fill="#3BAD2D" d="M109.12,150.66L79.49,180.3l9.86,9.86l19.75-19.75v27.94h13.95v-41.92C117.85,155.76,113.08,153.71,109.12,150.66"/>
        <path fill="#007934" d="M130.51,156.43v41.92h13.95v-27.94l19.75,19.75l9.86-9.86l-29.64-29.64C140.48,153.71,135.71,155.76,130.51,156.43"/>
      </svg>
    )}
  </div>
);

import AlertBell from "./AlertBell";

const WORKSHOP_CONTRACT_ID = "contract-parque-maquinaria";

const navItems = [
  { path: "/", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { path: "/planning", icon: CalendarDays, label: "Planificación" },
  { path: "/work-reports", icon: ClipboardList, label: "Partes de Trabajo" },
  { path: "/personnel", icon: Users, label: "Personal" },
  { path: "/fleet", icon: Truck, label: "Maquinaria" },
  { path: "/documents", icon: UploadCloud, label: "Documentos" },
  { path: "/weighing-tickets", icon: Scale, label: "Tickets Pesaje" },
  { path: "/fuel-tickets", icon: Fuel, label: "Tickets Combustible" },
  { path: "/punto-limpio", icon: Recycle, label: "Punto Limpio" },
  { path: "/workshop", icon: Wrench, label: "Taller", workshopOnly: true },
  { path: "/reports", icon: BarChart3, label: "Informes" },
  { path: "/anomalies", icon: AlertTriangle, label: "Anomalías" },
  { path: "/manual", icon: BookOpen, label: "Manual" },
  { path: "/admin", icon: ShieldCheck, label: "Administración", adminOnly: true },
];

const contractColors = {
  "contract-barakaldo": "#007934",
  "contract-sfh": "#3BAD2D",
  "contract-barcelona": "#0891B2",
  "contract-santa-eulalia": "#7C3AED"
};

export default function Layout() {
  const { user, logout, authAxios } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [workshopPendingCount, setWorkshopPendingCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const hasWorkshopAccess = user?.role === "admin" || (user?.contract_ids || []).includes(WORKSHOP_CONTRACT_ID);

  useEffect(() => {
    authAxios.get("/contracts").then(r => setContracts(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!hasWorkshopAccess) return;
    const loadPending = () => {
      authAxios.get("/workshop/maintenance-due")
        .then(r => setWorkshopPendingCount(r.data?.pending?.length || 0))
        .catch(() => {});
    };
    loadPending();
    const interval = setInterval(loadPending, 3 * 60 * 1000); // refresco ligero cada 3 min
    return () => clearInterval(interval);
  }, [hasWorkshopAccess]);

  return (
    <div className="flex h-screen overflow-hidden bg-[#F8FAFC]">
      {/* Sidebar */}
      <aside
        data-testid="sidebar"
        className={`sidebar flex flex-col transition-all duration-300 ${collapsed ? "w-20" : "w-72"} flex-shrink-0`}
      >
        {/* Logo */}
        <div className={`flex items-center border-b border-white/10 ${collapsed ? "p-4 justify-center" : "p-5"}`}>
          <ValorizaLogo collapsed={collapsed} />
          {!collapsed && (
            <button
              onClick={() => setCollapsed(true)}
              className="ml-auto text-white/40 hover:text-white/80 transition-colors"
            >
              <ChevronLeft size={18} />
            </button>
          )}
        </div>

        {/* Contracts */}
        {!collapsed && contracts.length > 0 && (
          <div className="px-4 py-3 border-b border-white/10 flex-shrink-0">
            <p className="text-white/40 text-xs font-semibold uppercase tracking-widest mb-2">Contratos</p>
            <div className="space-y-1 max-h-48 overflow-y-auto sidebar-scroll pr-1">
              {contracts.map(c => (
                <button
                  key={c.id}
                  data-testid={`contract-nav-${c.id}`}
                  onClick={() => navigate(`/contracts/${c.id}`)}
                  className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-all duration-150 ${
                    location.pathname === `/contracts/${c.id}`
                      ? "bg-white/15 text-white font-medium"
                      : "text-white/60 hover:text-white hover:bg-white/10"
                  }`}
                >
                  <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: c.color || "#007934" }} />
                  <span className="truncate">{c.name}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Navigation */}
        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto sidebar-scroll min-h-0">
          {navItems.filter(item =>
            (!item.adminOnly || user?.role === "admin") &&
            (!item.workshopOnly || user?.role === "admin" || (user?.contract_ids || []).includes(WORKSHOP_CONTRACT_ID))
          ).map(({ path, icon: Icon, label, exact, workshopOnly }) => (
            <NavLink
              key={path}
              to={path}
              end={exact}
              data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-150 relative ${
                  isActive
                    ? "bg-[#3BAD2D] text-white shadow-lg shadow-green-900/20"
                    : "text-white/60 hover:text-white hover:bg-white/10"
                } ${collapsed ? "justify-center" : ""}`
              }
            >
              <span className="relative flex-shrink-0">
                <Icon size={20} />
                {workshopOnly && workshopPendingCount > 0 && collapsed && (
                  <span data-testid="workshop-pending-badge-collapsed"
                    className="absolute -top-1.5 -right-1.5 w-2.5 h-2.5 rounded-full bg-red-500 ring-2 ring-[#0B2818]" />
                )}
              </span>
              {!collapsed && <span className="flex-1">{label}</span>}
              {workshopOnly && workshopPendingCount > 0 && !collapsed && (
                <span data-testid="workshop-pending-badge"
                  className="min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center flex-shrink-0"
                  title={`${workshopPendingCount} máquina(s) pendientes de revisión`}>
                  {workshopPendingCount}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="border-t border-white/10 flex-shrink-0 bg-black/20">
          {!collapsed && (
            <p className="text-white/30 text-[10px] font-medium uppercase tracking-widest px-4 pt-3 pb-2">
              Powered by Valoriza Innovation Team
            </p>
          )}
          <div className={`flex items-center gap-3 px-4 py-3 ${collapsed ? "justify-center" : ""}`}>
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#3BAD2D] to-[#007934] flex items-center justify-center text-white text-sm font-bold flex-shrink-0 shadow-md">
              {user?.name?.charAt(0)?.toUpperCase() || "V"}
            </div>
            {!collapsed && (
              <div className="flex-1 min-w-0">
                <p className="text-white text-sm font-semibold truncate leading-tight">{user?.name}</p>
                <p className="text-white/50 text-[11px] truncate leading-tight mt-0.5">{user?.email}</p>
              </div>
            )}
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="text-white/40 hover:text-red-400 hover:bg-white/5 transition-colors p-1.5 rounded-lg flex-shrink-0"
              title="Cerrar sesión"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header */}
        <header className="glass-header h-16 flex items-center px-6 gap-4 flex-shrink-0 z-10">
          {collapsed && (
            <button onClick={() => setCollapsed(false)} className="text-slate-500 hover:text-slate-800 transition-colors">
              <Menu size={20} />
            </button>
          )}
          <div className="flex-1 flex items-center gap-3">
            <div className="relative hidden md:flex items-center">
              <Search size={16} className="absolute left-3 text-slate-400" />
              <input
                type="text"
                placeholder="Buscar..."
                className="pl-9 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#007934]/20 focus:border-[#007934] w-56 transition-all"
              />
            </div>
          </div>
          <AlertBell />
          <div className="flex items-center gap-2 pl-2 border-l border-slate-200">
            <div className="w-8 h-8 rounded-full bg-[#007934] flex items-center justify-center text-white text-xs font-bold">
              {user?.name?.charAt(0)?.toUpperCase() || "V"}
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-semibold text-slate-800 leading-tight">{user?.name}</p>
              <p className="text-xs text-slate-500">{user?.role || "Admin"}</p>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
